import {
    BannersEditMassActions,
    CHANGE_LINK_BULK_EDITOR_NEW_LINK,
    CHANGE_LINK_BULK_EDITOR_PROTOCOL_LINK,
    CHANGE_LINK_BULK_EDITOR_SELECTED_LINK,
    CLOSE_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR,
    ON_ACCEPT_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR,
    ON_ACCEPT_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR,
    ON_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR_TUMBLER_CHANGED,
    OPEN_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR,
    SAVE_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR
} from '../../../actions/banners-edit/banners-edit-mass-actions';
import { selectAllBannersLinks } from '../../../selectors/bannerEdit/massActions/massActions';
import { getVisibleItems } from '../../../service/BannersEditMassActionsHelpers/BannersEditMassActionsHelpers';
import { BannersEditMassActionsState } from '../../../typings/bannersEditState';
import { State } from '../../../typings/state';

import { bannersEditMassActionsInitialState } from './banners-edit-mass-actions';

export function bannersEditMassActionsLinkReplaceReducer(
    state: BannersEditMassActionsState = bannersEditMassActionsInitialState,
    action: BannersEditMassActions,
    fullState: State
): BannersEditMassActionsState {
    switch (action.type) {
        case SAVE_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR:
        case CLOSE_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR:
            return bannersEditMassActionsInitialState;
        case ON_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR_TUMBLER_CHANGED: {
            const isSiteLinksTumblerChecked = !state[action.massActionId].data
                .isSiteLinksTumblerChecked;
            const visibleItems = selectAllBannersLinks(
                fullState,
                isSiteLinksTumblerChecked
            );

            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    data: {
                        ...state[action.massActionId].data,
                        isSiteLinksTumblerChecked,
                        visibleItems,
                        selectedSourceItems: visibleItems.map(val => val.id)
                    }
                }
            };
        }
        case ON_ACCEPT_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR:
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    errors: {},
                    inProgress: true
                }
            };
        case ON_ACCEPT_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR:
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    errors: {},
                    inProgress: true
                }
            };
        case CHANGE_LINK_BULK_EDITOR_NEW_LINK:
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    data: {
                        ...state[action.massActionId].data,
                        newVisibleLink: action.newVisibleLink
                    }
                }
            };
        case CHANGE_LINK_BULK_EDITOR_PROTOCOL_LINK:
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    data: {
                        ...state[action.massActionId].data,
                        selectedProtocolValue: action.selectedProtocolValue
                    }
                }
            };
        case CHANGE_LINK_BULK_EDITOR_SELECTED_LINK: {
            const visibleUrls = getVisibleItems(
                state[action.massActionId].data.selectedSourceItems,
                action.selectedSourceItems
            );

            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    data: {
                        ...state[action.massActionId].data,
                        visibleItems: selectAllBannersLinks(
                            fullState,
                            state[action.massActionId].data
                                .isSiteLinksTumblerChecked
                        ),
                        selectedSourceItems: visibleUrls
                    }
                }
            };
        }

        case OPEN_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR: {
            const visibleItems = selectAllBannersLinks(
                fullState,
                state[action.massActionId].data.isSiteLinksTumblerChecked
            );

            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    visibleModalActions: {
                        ...state[action.massActionId].visibleModalActions,
                        linkBulkReplacementEditorVisible: true
                    },
                    data: {
                        ...state[action.massActionId].data,
                        visibleItems,
                        selectedSourceItems: visibleItems.map(val => val.id)
                    }
                }
            };
        }
        default:
            return state;
    }
}
